import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import LoginImage from '../images/buyer-seller.jpg';
import Logo from '../images/logo.png';
import Navmain from '../main/header';
import Footer from '../main/footer';
import { navigateToBacktoOrDefault, SendWelcome, generateToken } from "./utils";

function Login() {
  const [permission, setPermission] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [uid, setUid] = useState('');
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [show, setShow] = useState(false);
  const [error, seterror] = useState("");

  useEffect(() => {
    try {

      const aa = localStorage.getItem("USER");
      if (aa != null) {
        navigate("/");
      }
      const fetchToken = async () => {
        const currentToken = await generateToken();
        if (currentToken) {
          setToken(currentToken);
        } else {
          console.log('No registration token available.');
        }
      };

      fetchToken();
    } catch (err) {
      console.error("🔥 useEffect error (iOS crash suspect):", err);
    }
  }, []);

  const handleClick = (id) => {
    SendWelcome(id, navigate);
    return false;
  };

  const loginNow = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const data = new FormData();
    data.append("email", email);
    data.append("pass", pass);
    data.append("status", "login");
    data.append("did", "web");
    data.append("dtype", "web");
    data.append("token", token);

    axios({
      method: "post",
      url: "/pro/auth/login.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setIsLoading(false);
        if (s.data[0].msg === "pass") {
          localStorage.setItem("USER", JSON.stringify(s.data));
          setUid(s.data[0].user);
          handleClick(s.data[0].user);
          navigateToBacktoOrDefault(navigate);
        } else if (s.data[0].msg === "block") {
          alert("Sorry! Your account is Disabled. please contact us at 021-372-95237");
        } else if (s.data[0].msg === "otp") {
          alert(s.data[0]?.message);
          const phone = email;
          localStorage.setItem("signupDetails", JSON.stringify({ phone, pass }));
          localStorage.setItem("currentPhone", email);
          if (!s.data[0]?.code) {
            navigate("/otp");
          }
        } else {
          alert("Invalid Phone or Password! Please try again.");
        }
      })
      .catch((s) => {
        setIsLoading(false);
        console.log("here catch ", s);
      });
  };

  const text_type = (input) => {
    const regex = /^[A-Za-z\s]+$/;
    return regex.test(input);
  };

  return (
    <div>
      <Navmain />
      <main className="main">
        <section className="bg-home9 no-gutters">
          <div className="container d-flex justify-content-center align-items-center">
            <div className="row w-100">
              <div className="col-6 d-none d-lg-block p-2">
                <div className="py-4 border-0 rounded login-content" style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                  <img className="form-image" src={LoginImage} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Login Visual" />
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="py-4 border-0 rounded login-content">
                  <div style={{ opacity: 0.9 }} className="login-form">
                    <h4 style={{ fontSize: '22px', color: '#1D2630', marginTop: "30px", letterSpacing: '1.4px' }} className="font-bold main-heading-style">Login with Phone Number</h4>

                    <div className={error === "phone" ? "form-group col-12 has-error" : "form-group col-12"}>
                      <div className="col-auto">
                        <label className="font-size-12"><i class="fas fa-phone mr-2"></i>Phone No</label>
                        <div className="input-group rounded">
                          <div className="input-group-prepend">
                            <span className="input-group-text" id="inputGroupPrepend"> +92 </span>
                          </div>
                          <input type="text" placeholder="Phone No" aria-describedby="inputGroupPrepend" className="form-control custom-placeholder" value={email} onChange={(v) => {
                            let newValue = v.target.value.replace(/[.-]/g, "");
                            if (newValue.charAt(0) === "0") newValue = "";
                            if (newValue.length < 11 && !text_type(newValue)) setEmail(newValue);
                            else if (newValue.length >= 11) seterror("phone");
                          }} />
                        </div>
                      </div>
                    </div>

                    <div className={error === "phone" ? "form-group col-12 has-error" : "form-group col-12"}>
                      <div className="col-auto">
                        <label className="font-size-12"><i class="fas fa-lock mr-2"></i>Password</label>
                        <div className="input-group rounded">
                          <input type={show ? "text" : "password"} placeholder="Password" aria-describedby="inputGroupPrepend" className="form-control custom-placeholder" onChange={(v) => setPass(v.target.value)} />
                        </div>
                      </div>
                    </div>

                    <div className="form-group col-12 has-error">
                      <div className="col-auto d-flex justify-content-between w-100">
                        <label className="d-flex align-items-center cursor-pointer">
                          <input type="checkbox" checked={show} onChange={() => setShow(!show)} style={{ marginRight: "5px" }} />
                          <span style={{ color: "#1B83B2", fontSize: "13px" }}>Show Password</span>
                        </label>
                        <a href="/forgotten" style={{ color: "black", fontSize: "13px", textDecoration: "underline", fontWeight: 600 }}>Forgot Your Password?</a>
                      </div>
                    </div>

                    <div className="form-group col-12 has-error">
                      <div className="col-auto">
                        <button onClick={(e) => {
                          if (email.length === 10) {
                            loginNow(e);
                          } else {
                            alert("Phone Number Invalid!");
                          }
                        }} className="btn btn-flat m-b-30 m-t-30 mx-auto" style={{ borderRadius: '30px', backgroundColor: '#2C99A1', border: '2px solid #2C99A1', color: 'white', boxShadow: 'rgb(204, 204, 204) 0px 0px 17px 6px', fontSize: '16px', fontWeight: 500 }} disabled={isLoading}>
                          {isLoading ? (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{" "}Please Wait...</>) : ("Login")}
                        </button>
                      </div>
                    </div>

                    <div className="register-link m-t-15 text-center">
                      <p>Don't have account ? <a href="signup" style={{ color: '#45ACB3' }}> Sign Up</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Login;
